import React from 'react';
import Container from "../../Wrappers/Container";
import ProcessPercentageItem from "../../Molecules/Items/ProcessPercentageItem";
import LastProcessEmptyState from "../Emptys/LastProcessEmptyState";

const DashboardLastProcess = () => {
  return (
    <Container className="m-cols-2">
      <header className="s-cross-center s-mb-2 m-mb-3">
        <h3 className="s-mb-0">Últimos procesos</h3>
        <a href="#"
          className="small s-to-right">Ve todos los procesos</a>
      </header>

      <div className="ed-grid m-grid-2 s-gap-2 m-gap-3 row-gap">
        <ProcessPercentageItem type="Nómina"
          status="Activo"
          percetage="20%"/>
        <ProcessPercentageItem type="Nómina"
          status="Error"
          percetage="70%"/>
        <ProcessPercentageItem type="Liquidación"
          status="Completado"
          percetage="100%"/>
      </div>

      {/*<LastProcessEmptyState/>*/}

    </Container>
  );
};

export default DashboardLastProcess;
